import { render, staticRenderFns } from "./KRadio.vue?vue&type=template&id=03523148&"
import script from "./KRadio.vue?vue&type=script&lang=js&"
export * from "./KRadio.vue?vue&type=script&lang=js&"
import style0 from "./KRadio.vue?vue&type=style&index=0&id=03523148&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports